import { render, staticRenderFns } from "./CustomerFilterRow.vue?vue&type=template&id=2783a076&lang=pug&"
import script from "./CustomerFilterRow.vue?vue&type=script&lang=js&"
export * from "./CustomerFilterRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
